import en from './translations/en/Footer.json';
import no from './translations/no/Footer.json';

type TranslationsType = {
  'en-GB': { [key: string]: string };
  'nb-NO': { [key: string]: string };
};

const translations: TranslationsType = {
  'en-GB': en,
  'nb-NO': no,
};

export { translations, TranslationsType };
